export default {
  name: 'inventaire-confirm-modal',
  props: {
    show: { type: Boolean, default: false },
    title: { type: String, default: '' },
    message: { type: String, default: '' },
    checkboxLabel: { type: String, default: '' },
    errorMessage: { type: String, default: '' },
    confirmLabel: { type: String, default: 'Confirmer' },
    inputId: { type: String, default: 'cfrm-inventaire' },
    loading: { type: Boolean, default: false },
    twoStep: { type: Boolean, default: true },
  },
  data () {
    return {
      confirmStep: false,
      confirmed: false,
      confirmError: false,
    }
  },
  watch: {
    show(value) {
      if (value) {
        this.confirmStep = false
        this.confirmed = false
        this.confirmError = false
      }
    },
  },
  methods: {
    goToConfirmStep() {
      this.confirmStep = true
    },
    onConfirmChange() {
      this.confirmError = false
    },
    confirm() {
      if (!this.confirmed) {
        this.confirmError = true
        return
      }
      this.$emit('confirm')
    },
    close() {
      this.$emit('close')
    },
  },
}
